// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoresizeController from "./autoresize_controller"
application.register("autoresize", AutoresizeController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import FormController from "./form_controller"
application.register("form", FormController)

import IngredientsController from "./ingredients_controller"
application.register("ingredients", IngredientsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NumberInputController from "./number_input_controller"
application.register("number-input", NumberInputController)

import ProgramExercisesController from "./program_exercises_controller"
application.register("program-exercises", ProgramExercisesController)

import SelectWithInputController from "./select_with_input_controller"
application.register("select-with-input", SelectWithInputController)

import SessionSortableController from "./session_sortable_controller"
application.register("session-sortable", SessionSortableController)

import TodoController from "./todo_controller"
application.register("todo", TodoController)
